import styled from '@emotion/styled'

export const FormStyled = {
  Form: styled.form<any>`
    width: 100%;
  `,
};
